<template>
  <div class="de-join-team">
    <h2>{{ title }}</h2>
    <div class="de-join-team__wrapper">
      <template v-for="(post, index) in posts">
        <div :key="index" class="de-join-team__item">
          <div class="de-join-team__sector">{{ post.acf.sector }}</div>
          <div class="de-join-team__position">{{ post.acf.position }}</div>
          <div class="de-join-team__city">{{ post.acf.city }}</div>
          <div class="de-join-team__button">
            <a
              v-if="post.acf.button_text"
              :href="'/jobs/' + post.slug"
              class="btn default"
              v-html="post.acf.button_text"
            ></a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
    name: "JoinTeam",
    data() {
        return {
            posts: null,
            title: this.blockdata.title,
        };
    },
    mounted: function() {
        this.fetchData();
        // console.log("blockata", this.blockdata);
    },
    props: ["blockdata"],
    methods: {
        fetchData: function() {

            var self = this;
            $.get(
                self.$root.apiUrl + "wp-json/wp/v2/jobs?per_page=100",
                function(response) {
                    self.posts = response;
                    self.$root.dataReady = true;
                    // console.log("posts:", response);
                }
            )
                .done(function() {})
                .fail(function() {});
        }
    }
};
</script>



// WEBPACK FOOTER //
// JoinTeam.vue?2b52a48c